module.exports = __webpack_public_path__ + "img/credit.68a24376.svg";